// eslint-disable-next-line import/no-unresolved
import Keycloak from 'keycloak-js';

// Setup Keycloak instance as necessary
// Pass initialization options as required or leave blank to load from 'keycloak.json'
const keycloak = new Keycloak({
  clientId: 'piaas',
  realm: 'pan-net.cloud',
  url: window.PORTAL_IDP_AUTH_SERVER_URL || import.meta.env.VITE_IDP_AUTH_SERVER_URL,
  'ssl-required': 'external',
  'public-client': true,
});

export default keycloak;
